import { CircularProgress } from "@mui/material";
import { ReactNode } from "react";
import { Modal } from "react-bootstrap";

import Button from "components/Button";

interface CancellationModalProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  onClickButton?: () => void;
  isLoading?: boolean;
  show: boolean;
  onHide: () => void;
  size?: "sm" | "lg" | "xl";
}

const defaultTitle = "Tem certeza que deseja cancelar?";
const defaultButtonText = "Confirmar";

const CancellationModal = ({
  title = defaultTitle,
  subtitle,
  buttonText = defaultButtonText,
  onClickButton,
  isLoading,
  ...rest
}: CancellationModalProps) => {
  return (
    <Modal {...rest} backdrop="static" centered>
      <Modal.Header
        closeButton
        className="justify-content-end pb-0 border-0"
      ></Modal.Header>
      <Modal.Body className="text-body">
        <div className="text-center">
          <p>
            <i className="uil uil-exclamation-triangle display-4" />
          </p>

          <h4>{title}</h4>
          {!!subtitle && <p>{subtitle}</p>}

          <p className="my-3">
            <Button
              type="button"
              className="btn-outline-danger"
              onClick={onClickButton}
              disabled={isLoading}
            >
              {buttonText}
              {!!isLoading && (
                <CircularProgress
                  color="inherit"
                  size={12}
                  className="align-text-top ms-2"
                />
              )}
            </Button>
          </p>
          {/* )} */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CancellationModal;
